import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Explains why the camera is needed before the browser permission prompt is triggered.
 * Closes with `true` when the user accepts to continue.
 */
@Component({
  selector: 'camera-permission-dialog',
  imports: [
    MatButton,
    MatIcon,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    TranslatePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './camera-permission-dialog.component.html',
  styleUrl: './camera-permission-dialog.component.scss',
})
export class CameraPermissionDialogComponent {}
